import no from './no';
import en from './en';

export default {
  en,
  no,
};
